import { render, staticRenderFns } from "./BaseRequestIndicator.vue?vue&type=template&id=5db98fef&scoped=true&lang=pug&"
import script from "./BaseRequestIndicator.vue?vue&type=script&lang=js&"
export * from "./BaseRequestIndicator.vue?vue&type=script&lang=js&"
import style0 from "./BaseRequestIndicator.vue?vue&type=style&index=0&id=5db98fef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db98fef",
  null
  
)

export default component.exports